import {
  PersonProfileListSchema,
  PersonProfileSchema,
  PersonWriteResponseSchema,
  type AllocationStatus,
  type EngagementType,
} from '@youkuai/contracts';

import { apiRequest } from './project-api.ts';

export interface PersonProfileInput {
  displayName: string;
  engagementType: EngagementType;
  company: string | null;
  department: string | null;
  jobTitle: string | null;
  phone: string | null;
  email: string | null;
  skills: string[];
  reason: string;
}

export async function listPeople(token: string) {
  return PersonProfileListSchema.parse(await apiRequest('/people', token));
}

export async function getPerson(token: string, personId: string) {
  return PersonProfileSchema.parse(await apiRequest(`/people/${encodeURIComponent(personId)}`, token));
}

export async function createPerson(token: string, input: PersonProfileInput & { allocationStatus: AllocationStatus }) {
  return PersonWriteResponseSchema.parse(await apiRequest('/people', token, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Idempotency-Key': `person-create-${crypto.randomUUID()}` },
    body: JSON.stringify(input),
  }));
}

export async function updatePerson(token: string, personId: string,
  input: PersonProfileInput & { expectedVersion: number }) {
  return PersonWriteResponseSchema.parse(await apiRequest(`/people/${encodeURIComponent(personId)}`, token, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', 'Idempotency-Key': `person-update-${crypto.randomUUID()}` },
    body: JSON.stringify(input),
  }));
}

export async function changePersonAllocationStatus(token: string, personId: string, input: {
  expectedVersion: number;
  allocationStatus: AllocationStatus;
  reason: string;
}) {
  return PersonWriteResponseSchema.parse(await apiRequest(`/people/${encodeURIComponent(personId)}/allocation-status`, token, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Idempotency-Key': `person-allocation-${crypto.randomUUID()}` },
    body: JSON.stringify(input),
  }));
}
